import { render, staticRenderFns } from "./TabelaMensalistas.vue?vue&type=template&id=15b8602f&scoped=true&"
import script from "./TabelaMensalistas.vue?vue&type=script&lang=js&"
export * from "./TabelaMensalistas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMensalistas.vue?vue&type=style&index=0&id=15b8602f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8602f",
  null
  
)

export default component.exports